import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-image: url("https://wallpaperaccess.com/full/1274146.jpg");
  background-size: cover;

  .user-sprite {
    position: absolute;
    max-width: 400px;
    max-height: 400px;
    bottom: 185px;
    left: 25%;
  }

  .enemy-sprite {
    position: absolute;
    max-width: 400px;
    max-height: 400px;
    bottom: 200px;
    right: 15%;
  }

  .status {
    position: absolute;
    bottom: 0;
    width: 70%;
    height: 200px;
    right: 5%;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    p {
      margin: 0;
    }
  }

  .attackName {
    color: #e8a22a;
  }

  .damage {
    color: #d93d3d;
  }

  .actions {
    position: absolute;
    bottom: 0;
    width: 20%;
    height: 600px;
    left: 5%;
    color: white;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .atk {
    position: initial;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;

    p {
      margin: 0;
    }

    button {
      border-radius: 15px;
      width: 100px;
      height: 50px;
      /* border: 2px black; */
      /* border: none; */
      background-color: #e8a22a;
      color: white;
      text-align: center;
      margin: 0;
      padding: 0;

      p {
        font-size: 11px;
        text-align: center;
        margin-left: 2px;
        width: 100%;
        margin: 0 auto;
      }
    }
  }

  .user-card {
    position: absolute;
    top: 5rem;
    left: 20%;
    width: 280px;
  }

  .enemy-card {
    position: absolute;
    top: 5rem;
    right: 20%;
    width: 280px;
  }
`;

export const VictoryModal = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    h1 {
      font-size: 25px;
    }

    p {
      font-size: 15px;
    }

    div {
      display: flex;
      width: 100%;
      justify-content: space-around;
      button {
        width: 45%;
      }
    }
  }
`;
